import { mapperModuleMedia } from '#layers/core/data-layer/modules/mappers'
import type { MapperOptions } from '#layers/core/types'

/**
 * Page licenses detail mapper
 * normalizes data to be used in pages
 *
 * @param {Object} data - cms data
 * @param {Function} getInternalUrl - returns localized url only for internal pages
 * @return {Object} - normalized page data
 */
export default (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }
  return {
    contentLocale: data.locale || '',
    introText: data.introText || null,
    highlightText: data.highlightText || null,
    chapters: data.chaptersCollection?.items || [],
    downloadDocument: mapperModuleMedia(data?.downloadDocument)?.link || null,
    navigationItems:
      data?.parent?.itemsCollection?.items.filter(Boolean).map((item) => ({
        title: item.navigationTitle,
        url: options.getInternalUrl(item.sys.id)
      })) || []
  }
}
